import ClassNames from "classnames";
import { FunctionComponent } from "react";
import styles from "../stylesheets/components/contact-nav.module.css";
import { Accommodation, ActionLinks, Language } from "../types/index.js";
import { getContactLinks, getQuickLinksWithIcon } from "../utils/utils.js";
import Icon from "./Icon.js";

interface Props {
  accommodation: Accommodation | undefined;
  actionLinks: ActionLinks;
  className?: string;
  languageId: Language;
}

const ContactNav: FunctionComponent<Props> = ({
  accommodation,
  className,
  actionLinks,
  languageId,
}) => {
  const links = [
    ...(accommodation ? getContactLinks(accommodation, languageId) : []),
    ...getQuickLinksWithIcon(actionLinks),
  ];

  if (!links.length) return null;

  return (
    <ul className={ClassNames(styles.ContactNav, className)}>
      {links.map(({ href, children, icon, type, title }) => (
        <li
          key={type}
          className={ClassNames(styles.ContactNav__ListItem, {
            [styles["ContactNav__ListItem--quick"]]:
              icon === "specials" || icon === "vouchers",
          })}
        >
          <a className={styles.ContactNav__Item} href={href} aria-label={title}>
            <Icon className={styles.ContactNav__Icon} glyph={icon} />
            <span className={styles.ContactNav__ItemText}>{children}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default ContactNav;
